'use client';

import { createContext, useContext } from 'react';
import { HeroCarouselApi } from './use-hero-carousel';

export const CarouselContext = createContext<HeroCarouselApi | null>(null);

export function useCarouselContext(): HeroCarouselApi {
  const ctx = useContext(CarouselContext);
  if (!ctx) {
    throw new Error('Carousel.* components must be rendered inside <Carousel>.');
  }
  return ctx;
}
